import DefinitionsContainer from './DefinitionsContainer';

export default { DefinitionsContainer };
